import { Button, Space, Spin, Table, Tag } from "antd";
import { useState } from "react";

import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Locale } from "../../utils";
import { showNotificationWithIcon } from "../../utils/helpers/helpers";
import { getList } from "../../utils/http/dataProvider";
import { getUserInfo } from "../../utils/redux/reducers/User";
import { useHistory } from "react-router-dom";
const i18n = Locale.getInstance();

const ProductTable = ({ agentLevelProduct = true }) => {
  const user = useSelector((state) => getUserInfo(state));
  const [page, setPage] = useState(1);
  let history = useHistory();
  const handleChangePage = (newPage) => {
    setPage(newPage);
  };
  const { data, error, isLoading } = useQuery(
    ["products", user.token, agentLevelProduct],
    () =>
      getList("product", {
        pagination: {
          perPage: 10,
          page,
        },
        sort: {
          field: "id",
          order: "desc",
        },
        query: {
          status: -1,
          agentLevelProduct,
        },

        token: user.token,
      })
  );

  if (error) {
    showNotificationWithIcon(error.data.message);
  }

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: i18n.t("course.order.status"),
      render: (item) => {
        return <Tag color={item.status === 1 ? "green" : "red"}>{item.status === 1 ? i18n.t("common.active") : i18n.t("common.inactive")}</Tag>;
      },
      width: 120,
    },
    {
      title: i18n.t("product.cats.name"),
      render: (item) => {
        return (
          <>
            <Space align="center" direction="vertical">
              <img
                src={`${item?.images[0]?.url}`}
                alt={i18n.getPropNameByLocale(item, "name")}
                width={60}
                height={60}
              />
            </Space>
          </>
        );
      },
    },
    {
      title: i18n.t("product.cats.name"),
      render: (item) => {
        return (
          <>
            <Space align="center" direction="vertical">
              <span>{i18n.getPropNameByLocale(item, "name")}</span>
            </Space>
          </>
        );
      },
    },
    {
      title: i18n.t("users.date"),
      dataIndex: "created_at",
      width: 200,
    },
    {
      title: i18n.t("product.cats.actions"),
      width: 100,
      render: (item) => {
        return (
          <>
            <Button
              type={"primary"}
              onClick={() => {
                history.push({
                  pathname: "/main/product/edit",
                  state: {
                    edit: true,
                    product: item,
                  },
                });
                return;
              }}
              size="small"
            >
              {i18n.t("product.productItem.actionEdit")}
            </Button>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Spin spinning={isLoading}>
        <div className="products">
          <Button
            style={{ marginBottom: 20 }}
            type="primary"
            onClick={() => {
              history.push({
                pathname: "/main/product/edit",
              });
            }}
          >
            {i18n.t("sales.activity.addProduct")}
          </Button>
          <Table
            className="list"
            rowKey="id"
            columns={columns}
            dataSource={data?.data}
            pagination={{ onChange: handleChangePage }}
            scroll={{
              y: 320,
            }}
          />
        </div>
      </Spin>
    </>
  );
};

export default ProductTable;
